export type Testimonial = {
  initials: string
  name: string
  location: string
  role: string
  text: string
}

/** Experiencias con materiales anteriores de Lumen Akasha (no reseñas del nuevo Kit). */
export const testimonials: Testimonial[] = [
  {
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    role: 'Terapeuta en Medicina Tradicional China',
    text: 'Por primera vez tengo una herramienta visual que puedo abrir en consulta y mostrarle al paciente el tema que estoy trabajando. La presentación transmite profesionalismo y me resulta práctica para explicar.',
  },
  {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    role: 'Acupunturista',
    text: 'Los materiales me ayudaron a ordenar conceptos que ya venía estudiando. Tener la información organizada y a mano hace más fácil volver sobre cada tema.',
  },
  {
    initials: 'CP',
    name: 'Carolina P.',
    location: 'La Plata',
    role: 'Terapeuta en MTC',
    text: 'Las fichas son simples de consultar y me sirven para tener la información más ordenada. Valoro poder volver al material cuando necesito repasar.',
  },
]
